import { config } from '@mp/config';
import { useCurrentUser, useProfileStats } from '@mp/hooks';
import React from 'react';
import { PerformanceTabContent } from './PerformanceTabContent';
import { ProfilePerformanceItem } from './ProfilePerformanceItem';
import { Divider } from '@medely/ui-kit';
import { HideFrom } from '../HideFrom';

export const Ratings = () => {
  const { isAgency } = useCurrentUser();
  const { do_not_sends_count, favorites_count } = useProfileStats();
  const helpLink = isAgency ? config.help.profileStatsAgency : config.help.profileStats;
  return (
    <PerformanceTabContent title="Since you've signed up">
      <HideFrom agency>
        <ProfilePerformanceItem
          title="Favorited By Facility"
          description="These facilities really enjoyed working with you and may request you for future shifts."
          count={favorites_count}
          link={helpLink}
        />
        <Divider />
      </HideFrom>
      <ProfilePerformanceItem
        title="Do Not Send (DNS)"
        description="There are many reasons why a facility may add a professional to their DNS list."
        count={do_not_sends_count}
        link={helpLink}
      />
    </PerformanceTabContent>
  );
};
